import header from '../Assests/header.PNG';
import bottom from '../Assests/bottom.PNG';
import {
    Box,
    TableBody,
    TableCell,
    TableContainer,
    TableHead,
    TableRow,
    Table
} from "@mui/material";
import React from 'react';

export default class DoctorDetailsReport extends React.Component {
    render() {

        const doctorList = this.props.doctorList;

        return (
            <div>
                {/* Header Section */}
                <div className="header">
                    <img
                        src={header}
                        height="auto"
                        width="100%"
                        alt="Header Logo"
                    />
                </div>

                {/* Table Section */}
                <div className="print-content">
                    {/* Title */}
                    <br />
                    <h2 style={{ textAlign: 'center' }}>Supplier Details Report</h2>
                    <hr />
                    <br />
                    <Box minWidth={1050}>
                        <TableContainer>
                            <Table sx={{ minWidth: 500 }} aria-label="a dense table">
                                <TableHead>
                                    <TableRow>
                                        <TableCell align="left" sx={{ fontWeight: 'bold', textTransform: 'uppercase', fontSize: '15px' }}>#</TableCell>
                                        <TableCell align="left" sx={{ fontWeight: 'bold', textTransform: 'uppercase', fontSize: '15px' }}>Doctor Name</TableCell>
                                        <TableCell align="left" sx={{ fontWeight: 'bold', textTransform: 'uppercase', fontSize: '15px' }}>Contact No</TableCell>
                                        <TableCell align="left" sx={{ fontWeight: 'bold', textTransform: 'uppercase', fontSize: '15px' }}>Role</TableCell>
                                    </TableRow>
                                </TableHead>
                                <TableBody>
                                    {doctorList.map((row, index) => (
                                        <TableRow key={row._id}>
                                            <TableCell align="left">{index + 1}</TableCell>
                                            <TableCell align='left'>{row.Name}</TableCell>
                                            <TableCell align='left'>{row.Phone}</TableCell>
                                            <TableCell align='left'>{row.Role === 1 ? "Intern" : row.Role === 2 ? "Part Time" : "Full Time"}</TableCell>
                                        </TableRow>
                                    ))}
                                </TableBody>
                            </Table>
                        </TableContainer>
                    </Box>
                </div>

                {/* Footer Section */}
                <div className="footer">
                    <img
                        src={bottom}
                        height="auto"
                        width="100%"
                        alt="Footer Logo"
                    />
                </div>

                {/* Print-specific CSS */}
                <style jsx="true">
                    {`
                        @media print {
                            @page {
                                size: A4;
                                margin: 5mm;
                            }

                            body {
                                margin: 0;
                                -webkit-print-color-adjust: exact;
                            }

                            .header {
                                position: fixed;
                                top: 0;
                                width: 100%;
                            }

                            .footer {
                                position: fixed;
                                bottom: 0;
                                width: 100%;
                            }

                            .print-content {
                                margin-top: 100px; /* Adjust for header height */
                                margin-bottom: 100px; /* Adjust for footer height */
                            }

                            table {
                                width: 100%;
                                border-collapse: collapse;
                            }

                            th, td {
                                border: 1px solid black;
                                padding: 8px;
                                font-size: 12px;
                            }

                            th {
                                background-color: #f0f0f0;
                            }
                        }
                    `}
                </style>
            </div>
        );
    }

}
